import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearNewHireState } from '../new-hire-slice';

export function useNewHireState() {
	const dispatch = useDispatch();

	useEffect(() => {
		// clear info when app unmounts
		return function cleanup() {
			dispatch(clearNewHireState());
		};
	}, []);
}